// @ts-check
import _ from 'lodash';
import NodeDashboard from './NodeDashboard';
import Icons, { Size } from '../../Common/Icons';
import React from 'react';
import { replaceName } from 'components/Dashboard/useDashboardsQuery';

/**
 *
 * @param {import('components/Dashboard/DashboardPropTypes').DashboardType[]} dashboards
 * @param {function} dashboardDate
 * @returns {import('components/Tabs/Tabs').TabType[]}
 */
const dashboardTabs = (dashboards, dashboardDate) => {
  return _.map(dashboards, dashboard => ({
    // TODO: Fix when all dashboards uses displayName
    label: replaceName(dashboard.displayName ?? dashboard.name),
    component: NodeDashboard,
    props: { dashboard, dashboardDate },
    icon: <Icons.Dashboard size={Size.SMALL}/>
  }));
};

export default dashboardTabs;
